<template>
  <div>
    <FormGroup
      label="Share your experience"
      :help="helperText"
      required
    >
      <Textarea
        v-model="localValue"
        :rows="6"
        placeholder="What was it like working here?"
        class="w-full resize-none"
        :maxlength="maxLength"
      />
      <small class="text-gray-500">{{ maxLength - localValue.length }} characters remaining</small>
    </FormGroup>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string
  maxLength: number
  helperText?: string
}>()
const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()
const localValue = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value)
})
</script>
